// lib
import React, { useRef, useEffect, useReducer } from 'react'
// import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import ADND from '@aytm/lib/adnd/ADND'

import useEventListener from '@aytm/app/stats/hooks/useEventListener'

import { dropTargetReducer } from '@aytm/app/stats/page/sidebar/components/reducers'

// styles
import style from '@aytm/app/stats/page/sidebar/components/styles/DropTargetContainer.module.scss'

const DropTargetContainer = ({ children, root, acceptTypes, typesTitles, windowUID, onDNDDrop }) => {
  const [state, dispatch] = useReducer(dropTargetReducer, {
    showDropTarget: false,
    dropTargetHTML: ''
  })

  const dndDropTargetRef = useRef(null)

  const dndDropTarget = state.showDropTarget
    ? ADND.targets
        .data({
          acceptTypes,
          dynamicPosition: true
        })
        .onDrop(data => {
          if (windowUID != data.data.windowUID) return
          onDNDDrop(data.data)
        })
    : null

  useEffect(() => {
    if (state.showDropTarget && null === dndDropTargetRef.current) {
      dndDropTargetRef.current = document.createElement('div')
      dndDropTargetRef.current.className = style['drop-target']
      root.appendChild(dndDropTargetRef.current)
    }

    if (dndDropTarget) dndDropTarget.connect(dndDropTargetRef.current)

    return () => {
      if (dndDropTarget) dndDropTarget.disconnect()

      if (root.contains(dndDropTargetRef.current)) {
        root.removeChild(dndDropTargetRef.current)
      }
      dndDropTargetRef.current = null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dndDropTarget])

  useEventListener('showDropTarget', event => {
    if (Object.hasOwn(event.detail, 'type') && acceptTypes.includes(event.detail.type)) {
      if (event.detail.show) {
        const type = typesTitles[event.detail.type]
        const html = `<b>Drop your ${type} here</b><br/>if you want to use it's clone in a different report of this survey.<br/><br/>Original ${type} will remain in the report on the right and its clone will be temporary saved in this tab and available for some time in your browser.`

        dispatch({ type: 'SHOW_DROP_TARGET', request: { html } })
      } else dispatch({ type: 'HIDE_DROP_TARGET' })
    } else dispatch({ type: 'HIDE_DROP_TARGET' })
  })

  return state.showDropTarget ? (
    <div className={style.component} dangerouslySetInnerHTML={{ __html: state.dropTargetHTML }}></div>
  ) : (
    <>{children}</>
  )
}

DropTargetContainer.propTypes = {
  children: PropTypes.any,
  root: PropTypes.any,
  acceptTypes: PropTypes.array,
  typesTitles: PropTypes.object,
  windowUID: PropTypes.string,
  onDNDDrop: PropTypes.func
}

DropTargetContainer.displayName = 'DropTargetContainer'

export default DropTargetContainer

ADND().connect()
